export const Navigation = (props) => {
  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='container'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            <span className='sr-only'>Toggle navigation</span>
            <span className='icon-bar'></span>
            <span className='icon-bar'></span>
            <span className='icon-bar'></span>
          </button>

          {/* Brand — logo + wordmark */}
          <a className='navbar-brand page-scroll nav-brand-wrap' href='#page-top'>
            <div className='nav-logo-pill'>
              <img src='img/newgen_logo.jpg' alt='NewGen Solar' className='nav-logo-img' />
            </div>
            <span className='nav-brand-text'>
              NewGen <span className='nav-brand-accent'>Solar</span>
            </span>
          </a>
        </div>

        <div className='collapse navbar-collapse' id='bs-example-navbar-collapse-1'>
          <ul className='nav navbar-nav navbar-right nav-links'>
            <li><a href='#features'   className='page-scroll'>Why Solar</a></li>
            <li><a href='#why-us'     className='page-scroll'>Why Us</a></li>
            <li><a href='#calculator' className='page-scroll'>Calculator</a></li>
            <li><a href='#services'   className='page-scroll'>Services</a></li>
            <li><a href='#portfolio'  className='page-scroll'>Projects</a></li>
            <li><a href='#team'       className='page-scroll'>Team</a></li>
            <li><a href='#offices'    className='page-scroll'>Offices</a></li>
            <li className='nav-cta-item'>
              <a href='#contact' className='page-scroll nav-cta-btn'>
                Get Free Quote
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}
